import {
  Ref,
  ref,
  computed,
  ComponentInternalInstance,
  getCurrentInstance,
  onUnmounted,
  onMounted,
} from '@vue/composition-api';

import i18n, { i18n_t } from '@/locales/i18n';
import user from '@/renderer/scripts/utils/user';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';
import tips from '@/renderer/scripts/utils/tips';
import { httpUrl, CONSTANT_URL } from '@/renderer/scripts/http';
import vistor from '@/renderer/scripts/utils/vistor';
import { OrgLogoInfo } from '@/renderer/scripts/libs/smh-sdk-class/typings';

interface DropOption {
  content: string;
  value: string;
}
type Handler = {
  orgName: Ref<string>;
  orgLogo: Ref<string>;
  dropOptions: Array<DropOption>;
  isShareRoute: Ref<boolean>;
  showSetting: Ref<boolean>;
  showUpgrade: Ref<boolean>;
  showLogin: Ref<boolean>;
  vistorLogin: Ref<boolean>;
  showOrgName: Ref<boolean>;
  methods: {
    openCofileGuide: () => void;
    showNotice: () => void;
    onLoginSuccess: () => void;
    onVistorLoginSuccess: () => void;
    mobileOffence: () => void;
    /**
     * @description
     */
    onOperateEventProxy: (
      command: 'app' | 'setting' | 'changeRoute' | string,
      options?: {
        route?: RouteItem;
      },
    ) => void;
  };
};

export default function headbarHandler(orgLogoInfo?: Ref<OrgLogoInfo>): Handler {
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const store = vm.$store;
  // 分享外链、文件收集、成员邀请（协作成员，企业成员，临时成员）优先展示orgLogoInfo的信息
  const orgName = computed(() => orgLogoInfo?.value?.orgName || store.getters.orgName);
  const showOrgName = computed(() =>
    orgLogoInfo?.value?.showOrgNameInUI !== undefined ? orgLogoInfo?.value?.showOrgNameInUI : store.getters.showOrgName,
  );
  const orgLogo = computed(() => orgLogoInfo?.value?.orgLogo || store.getters.orgLogo);
  const isShareRoute = ref(vm.$route.name === 'share');
  const showSetting = ref(false);
  const showUpgrade = ref(false);
  const showLogin = ref(false);
  const vistorLogin = ref(false);
  const dropOptions = [
    {
      content: i18n_t('举报文件'),
      value: 'offence',
    },
  ];
  const methods = {
    // 跳往消息通知页面
    showNotice() {
      ipc.emit(ipc.RENDERER_EVENTS_MAP.WEB_TRANS_SHOW, {
        show: false,
      });
      ipc.emit(ipc.RENDERER_EVENTS_MAP.NOTICE_CENTER_SHOW, {
        show: true,
      });
    },
    // 打开用户使用手册
    openCofileGuide() {
      dispatchRouter(httpUrl.staticCDNURLMap.userManualUrl);
    },
    async onLoginSuccess() {
      tips.success(i18n_t('登录成功'));
      showLogin.value = false;
      // 加载企业信息
      const { organizationId } = user.getUserInfo();
      (organizationId as number) > 0 && store.dispatch('GetOrgInfo', organizationId);
    },
    async onVistorLoginSuccess() {
      tips.success(i18n_t('登录成功'));
      showLogin.value = false;
      // 加载用户信息
      const { vistorPhoneNumber } = vistor.getUserInfo();
      store.commit('SET_VISTOR_PHONE_NUMBER', vistorPhoneNumber);
    },
    mobileOffence() {
      ipc.emit(ipc.RENDERER_EVENTS_MAP.OFFENCE_SHOW);
    },
    onOperateEventProxy(
      command: 'app' | 'setting' | 'changeRoute' | string,
      options: {
        route?: RouteItem;
      } = {},
    ) {
      switch (command) {
        case 'setting': {
          showSetting.value = true;
          break;
        }
        case 'app':
          dispatchRouter(CONSTANT_URL.appUrl);
          if (vm.$router.currentRoute.name === 'share') {
            reporter.report('link_view', {
              link_view_officialwebsite: store.getters.isLogined ? 'login' : 'nologin',
            });
          }
          break;
        case 'changeRoute': {
          if (options.route) {
            if (options.route.route === vm.$router.currentRoute.name) return;
            dispatchRouter({
              name: options.route.route,
            });
          }
          break;
        }
        default:
          break;
      }
    },
    // 响应托盘菜单消息
    onTrayMenuEvent(opt: any, param: any) {
      const { event, id } = param;
      switch (event) {
        case 'swith-org':
          showSetting.value = false;
          break;
        case 'update':
          ipc.emit(ipc.RENDERER_EVENTS_MAP.CHECK_UPDATE);
          break;
        case 'setting':
          methods.onOperateEventProxy('setting');
          break;
        default:
          break;
      }
    },
  };
  onMounted(() => {
    ipc.on(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
  });
  onUnmounted(() => {
    ipc.off(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
  });
  return {
    orgName,
    orgLogo,
    dropOptions,
    isShareRoute,
    showSetting,
    showUpgrade,
    showLogin,
    vistorLogin,
    showOrgName,
    methods,
  };
}
